import React, { useContext } from "react"
import { Context } from "../store/UserProvider"
import * as Style from "./LogInTest.module.scss"
import Button from "../UI/button/Button"

const LogInTest = props => {
  const ctx = useContext(Context)
  return (
    <React.Fragment>
      <div className={Style.logInDiv}>
        {ctx.userGlobalState && (
          <div className={Style.info}>
            <div
              className={Style.userDiv}
            >{`Username: ${ctx.userGlobalState.name} Email: ${ctx.userGlobalState.email}`}</div>
            {/* <div
              className={Style.token}
            >{`User Token: ${ctx.userGlobalState.token}`}</div> */}
            <div className={Style.logOutBtnWrapper}>
              <Button buttonHandler={ctx.logOutHandler} style={Style.logOutBtn}>
                Log out
              </Button>
            </div>
          </div>
        )}
        {!ctx.userGlobalState && (
          <div className={Style.userDiv}>No active user</div>
        )}
      </div>
      {props.children}
    </React.Fragment>
  )
}

export default LogInTest
